//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import * as React from "react";
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import { withRouter } from "react-router";
import { Button } from "@mui/material";
import { Colours as MyColours } from "myriota-common/constant";

const styles = createStyles({
  container: {
    height: 78,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    padding: 24,
    backgroundColor: MyColours.BLUE_100,
  },
  developerLogo: {
    overflow: "hidden",
    width: "226px",
    // require for link
    position: "relative",
    height: "100%",
        '@media (max-width: 640px)': {
            display: "none"
    },
    display: "flex",
  },
  normalLogo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
        '@media (max-width: 640px)': {
            display: "flex"
    },
        display: "none"
  },
  left: {
    display: "flex",
    alignItems: "center",
    columnGap: "12px",
        color: MyColours.WHITE
  },
  button: {
    fontSize: 16,
    fontWeight: "bold",
    border: "none",
    display:"flex",
    flex: "0 0 auto",
    color: MyColours.WHITE,
    "&:hover": {
      color: MyColours.BLUE_50,
      backgroundColor: "unset",
    },
    }
});

export interface IHeaderComponentState {
  className?: string;
  redirectFrom?: string;
}

export interface IHeaderComponentProps extends WithStyles<typeof styles> {
  className?: string;
  location?: any; // injected by react-router
  history: any; // injected by react-router
}

export class HeaderComponent extends React.Component<IHeaderComponentProps, IHeaderComponentState> {
  constructor(props: IHeaderComponentProps) {
    super(props);
    this.state = {
            redirectFrom: this.props.location.pathname
        }
    this.onButtonClick = this.onButtonClick.bind(this);
  }

    componentDidUpdate(prevProps: IHeaderComponentProps, prevState: IHeaderComponentState) {
    if (this.props.location !== prevProps.location) {
      this.setState({
                redirectFrom: this.props.location.pathname
            })
    }
  }

  onButtonClick(event: any) {
        this.props.history.push(`/${event.target.value}`)
  }

  render() {
    const cssClasses = this.props.classes;
    const containerStyle = this.props.className
      ? `${this.props.className} ${cssClasses.container}`
      : cssClasses.container;
    return (
      <div className={containerStyle}>
        <div className={cssClasses.left}>
          <a href="https://support.myriota.com/hc/en-us?kb">
                     <img src="https://static.myriota.com/logo/myriota_developer_multiple_lines.png" alt="logo" className={cssClasses.developerLogo} />
          </a>
                    <img src="https://static.myriota.com/logo/icon-white.png" alt="logo" className={cssClasses.normalLogo} />
          <Button
            variant="text"
            onClick={this.onButtonClick}
            className={cssClasses.button}
            value="accesstimes"
          >
            AccessTimes
          </Button>
          <Button
            variant="text"
            onClick={this.onButtonClick}
            className={cssClasses.button}
            value="modules"
          >
            Modules
          </Button>
          <Button
            variant="text"
            onClick={this.onButtonClick}
            className={cssClasses.button}
            value="destinations"
          >
            Destinations
          </Button>
          <Button
            variant="text"
            onClick={this.onButtonClick}
            className={cssClasses.button}
            value="devicecontrol"
          >
            Device Control
          </Button>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(HeaderComponent));
